<template>
  <div class="book">
    <div class="container btnP searchDV text-center pt-2">
        
      <button class="btn btn-info btnP" @click="prt()">طباعة</button>
    </div>

    <div class="page1" v-for="itm in lng" :key="itm">
      <div class="subpage">
        <header class="row">
          <div class="col-4 pt-4">
            شركة الصافنات للنقل
          </div>
          <div class="col-4">
            <p class="text-center">بسم الله الرحمن الرحيم</p>
            <h3 class="text-center">عقد نقل مدرسى</h3>
            <p class="text-center"><span>رقم العقد  /</span>
            <span>{{items.id}}</span>


            </p>
          </div>
          <div class="col-4 text-left">
            <img src="../../../public/static/img/logo.png" alt="" />
            <p class="text-left"><span>الجوال / </span> <span> 0505575095</span></p>
            <p class="text-left"><span>الهاتف / </span> <span> 2422839</span></p>
             <p class="text-left"><span>تحويلة / </span> <span> 12</span></p>
          </div>
        </header>
        <div class="bd">
      <div class="row">
          <div class="col-6">
 <span>اسم الجامعة / </span><span>{{items.collageName}}</span>
          </div>
         <div class="col-6">
<span>المرحلة / </span><span>{{items.nLevel}}</span>
         </div>
      
      </div>
      <div class="row">
          <div class="col-6"><span>اسم الطالبة / </span><span>{{items.Fname}}   &nbsp; {{items.Sname}} &nbsp; {{items.Tname}} &nbsp; {{items.Ffname}}</span>
      </div>
          <div class="col-6"><span>جوال الطالبة / </span><span>{{items.mob}}</span></div>

      </div>
        <div class="row">
          <div class="col-6"><span>اسم ولى الامر / </span><span> {{items.Sname}} &nbsp; {{items.Tname}} &nbsp; {{items.Ffname}}</span>
      </div>
          <div class="col-6"><span>جوال ولى الامر / </span><span>{{items.mobFather}}</span></div>

      </div>
              <div class="row">
          <div class="col-6"><span>  اسم الحى / </span><span> {{items.dName}} </span>
      </div>
          <div class="col-6"><span>العنوان / </span><span>{{items.addressFather}}</span></div>

      </div>
              <div class="row">
          <div class="col-6"><span>  نوع الخدمة / </span><span> {{srv.name}} </span>
      </div>
          <div class="col-6"><span>مدة التعاقد / </span><span>{{dur.name}}</span></div>

      </div>
<hr>
           <div class="row">
          <div class="col-6"><span>  طرف اول / </span><span> الصافنات للنقل الجامعى</span>
      </div>
          <div class="col-6"><span>طرف ثان / </span><span>{{items.Sname}} &nbsp; {{items.Tname}} &nbsp; {{items.Ffname}}</span></div>

      </div>
         <div class="row">
          <div class="col-6"><span>  ويمثلها مديرهاالعام / </span><span> شجاع مبارك الشجاع</span>
      </div>
          <div class="col-6"><span>ويمثل الطالبة / </span><span>{{items.Fname}}   &nbsp; {{items.Sname}} &nbsp; {{items.Tname}} &nbsp; {{items.Ffname}}</span></div>

      </div>
            <div class="row">
          <div class="col-6 mt-4"><span> لقد تم الاتفاق بين كل من الطرفين على مايلى :-</span>
      </div>

      </div>
         <div class="row mt-3">
          <div class="col-12"><span>1)</span><span>أن يقوم الطرف الاول بنقل الطالبة من البيت الى الجامعة بحى </span><span> {{colDist.dName}}</span>
          <span>نظير آجرة فصل دراسى قدرها </span><span>({{items.AmountSub}} )</span>
          <span>ريالاً</span>
      </div>
<div class="col-12"><span>2)</span><span> يسدد الطرف الثانى قيمة الاشتراك للطرف الاول مقدماً او بداية الاشتراك كل شهر هجرى فى المكتب عند </span>
<span> بدء كل فترة او تسليمها لمن يفوضة المكتب بالاستلام (السائق) , مع طلب سند القبض منه.</span>
          </div>
          <div class="col-12"><span>3)</span><span> يلتزم الطرف الاول بتأمين سيارة من نوع حافلة او فانات مكيفة لنقل الطرف الثانى. </span>
          </div>
           <div class="col-12"><span>4)</span><span> يلتزم الطرف الاول بتأمين سيارة إحتياطية فى حالة عطل السيارة الى ان يتم إصلاحها. </span>
          </div>
              <div class="col-12"><span>5)</span><span> فى حال لم يتم سداد الاشتراك خلال الايام الثلاث الاولى يحق للطرف الاول ايقاف اخدمة النقل عن الطالبة . </span>
          </div>
              <div class="col-12"><span>6)</span><span> لا يحق للطرف الثانى خصم ايام الغياب الاقل من اسبوعين باى حال من الاحوال , وفى حال الرغبة بأخذ اجازة اكثر من اسبوعين  </span>
        <span>فإنه يلزم ابلاغ الطرف الاول قبل بدء الشهر الذى ستأخذ الطالبة فيه الاجازة باسبوع على الاقل .</span>
          </div>
            <div class="col-12"><span>7)</span><span>على الطالبة الالتزام بالحجاب الكامل داخل السيارة وكل طالبة مسؤولة عن تصرفاتها واة اخل بهذا الشرط يحق للطرف الاول فسخ العقد واشعار ولى الامر بذلك . </span>
          </div>
          <div class="col-12"><span>8)</span><span>إذا حدث تأخير من الطالبة فى الصباح أكثر من خمس دقائق يحق للسائق الذهاب حرصاً على مواعيد باقى الطالبات . وكذلك فى العودة لا يحق للطالبة التأخر اكثر من عشر دقاؤق . </span>
          </div>
           <div class="col-12"><span>9)</span><span> يجب على الطرف الثانى ابلاغ الطرف الاول فى حال اراد ايقاف النقل , وإلا تعتبر مدة الايقاف محسوبة . </span>
          </div>
           <div class="col-12"><span>10)</span><span> الدفع مقدماً , ولا يحق للطرف الثانى استرداد مبلغ الرسوم بعد مضى اسبوعين من بداية العمل  </span>
           <span>(للنظام الفصلى)</span>
           <span>او اسبوع  </span>
           <span>(للنظام الشهرى) .</span>
          </div>
           <div class="col-12"><span>11)</span><span> العقدإلكترونى , وعند طلب العميل يسلم نسخة منه .</span>
          </div>
           <div class="col-12"><span>12)</span><span>العقد ملزم بعد استلام العميل سند قبض الرسوم . </span>
          </div>
             <div class="col-12 pb-3">
                 <span>....................................................................................................</span>
                 <span>والله ولى التوفيق</span>
                  <span>....................................................................................................</span>
          </div>
          <div class="col-4">
<div>الطرف الاول</div>
<div>الصافنات للنقل الجامعى</div>
          </div>
               <div class="col-4">
  <p class="text-center"> الختم</p>
          </div>
               <div class="col-4">
<div>الطرف الثانى</div>
<div>ولى امر الطالبة</div>
<div><span>{{items.Sname}} &nbsp; {{items.Tname}} &nbsp; {{items.Ffname}}</span></div>
          </div>
      </div>

        </div>
        <footer class="row footer">
          <div class="col-4">
            <span>رقم الصفحة </span>
            <span>{{ itm }}</span>
            <span> | </span>
            <span> {{ lng }} </span>
          </div>
          <div class="col-4 "></div>
          <div class="col-4">
            <span>التاريخ</span>
            <span> / </span>
            <span>{{dt}} </span>
          </div>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import reportsLayout from "../../layouts/reportsLayout.vue";

export default {
  name: "driverR",
  data() {
    return {
        items:'',
      lng: 0,
      datalng: 0,
      cunt: 10,
      indx: 0,
      kwd: 0,
      dt:'',
      inx:1,
      sst:'',
      ppt:'',
      services:'',
      duration:'',
      loadsub:[],
      srv:'',
      dur:'',
      colDist:''      

    };
  },
   props:['id'],
  computed: {
    ...mapGetters({
      std: "stdMod/GET_STDVIEW",
      colg: "collagesMod/GET_ALLDATA",
      distc: "GET_DISTRICT",
      servic: "GET_SERVICE",
      loadDuration: "GET_DURATION"
    }),
  },
  created() {
    this.$emit("update:layout", reportsLayout);
     this.loadData();
    this.loadDate();
    this.reportLoad();
  },
  methods: {
   loadData(){
      this.items = this.std.find((t)=> t.id == this.id);
      var tdi = this.items.transfareType_id;
      var cdi = this.items.contractType_id;
      var collg = this.items.Collage_id;
      this.srv = this.servic.find((t)=>t.id == tdi);
      this.dur = this.loadDuration.find((t)=>t.id == cdi);
      var colD = this.colg.find((t)=>t.id == collg);
      this.colDist =  this.distc.find((t)=>t.id == colD.District);
      
   },
    reportLoad() {
      if (this.loadsub != null) {
        this.indx = this.loadsub.length - 1;
        var lln = Math.floor(this.loadsub.length / this.cunt);
        if (lln < 1) {
          this.cunt = this.loadsub.length ;
          this.lng = 1;
        } else {
          this.lng = Math.ceil(this.loadsub.length / this.cunt);
          var ss = this.cunt * lln;
          this.kwd = this.loadsub.length - ss;
        }
       
        //window.print();
      }
    }, addnum: function(indx, itm) {
      
     this.inx += 1; 

    this.indx = this.indx - 1 
    
      if (itm == this.lng) {

        if (this.kwd > 1) {
            
          if (this.indx == this.kwd - 1) {
           
           this.cunt = this.indx;
          }

        } else if(this.kwd == 1) {

          if (this.indx == 1) {
            this.cunt = 1;
          }
          
        }
      }
      /* var chk = this.loadsub[indx].id;
      if(chk == 'undefind'){
      this.indx = chkV;
      } */
    },
    prt() {
      window.print();
    },
    loadDate(){
      const event = new Date();
       const options = {
            weekday: "long",
            year: "numeric",
            month: "long",
            day: "numeric"
        }
     this.dt = event.toLocaleDateString('ar-SA', options);
    }
  },
}
</script>

<style lang="scss" scoped>
@import "../../../public/static/css/print.css";
.searchDV {
  height: 50px;
  width: 790px;
  background-color: white;
}
.bd {
  height: 940px;
  margin-top: -70px;
}
.pad{
    padding-right: 250px;
}
thead{
 background-color: #d4d4d4; 
}

.col-12{
    margin-top: 5px;
}
.footer{
    margin-top: -35px;
}
</style>
